import React, { useEffect, useState, useCallback } from 'react';
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";
import { useMediaQuery } from 'react-responsive';

import ScrollToTopOnMount from "../ScrollToTopOnMount";
import Header from "../Header";
// import PageScroll from "../PageScroll";
import Hero from "../Hero";
// import Listener from "../Listener";
// import About from "../About";
// import Contact from "../Contact";
// import Form from "../Form";
import DemoForm from "../DemoForm";
// import Footer from "../Footer";

const Home = () => {
    gsap.registerPlugin(ScrollSmoother, ScrollTrigger, DrawSVGPlugin);
    const [isFormHidden, setIsFormHidden] = useState(true);
    const [isDemoFormHidden, setIsDemoFormHidden] = useState(true);
    const [isPageLoaded, setIsPageLoaded] = useState(false);

    const isXsScreen = useMediaQuery({ query: '(max-width: 480px)' });
    const isSmScreen = useMediaQuery({ query: '(max-width: 768px)' });
    const isMdScreen = useMediaQuery({ query: '(max-width: 992px)' });
    const isLgScreen = useMediaQuery({ query: '(max-width: 1200px)' });

    const screens = { isXsScreen, isSmScreen, isMdScreen, isLgScreen };

    const appHeightHandle = () => {
        document.querySelector('body').style.setProperty('--app-height', window.innerHeight + 'px');
    }

    appHeightHandle();

    useEffect(() => {
        if (!isLgScreen) {
            window.addEventListener('resize', () => {
                appHeightHandle();
            });
        }
    }, [isLgScreen]);

    useEffect(() => {
        let smoother = ScrollSmoother.create(
            isLgScreen ? {
                smooth: 2,
                smoothTouch: true,
                normalizeScroll: true
            } : {
                wrapper: "#smooth-wrapper",
                content: "#smooth-content",
                smooth: 3,
                effects: true,
                normalizeScroll: false,
                ease: 'power4.out',
            }
        );

        if (!isLgScreen) {
            smoother.scrollTrigger.getVelocity();
        }

        return () => {
            if (smoother) smoother.kill();
        };
    }, [isLgScreen]);

    useEffect(() => {
        const smoother = ScrollSmoother.get();

        if (smoother) {
            if (isFormHidden && isDemoFormHidden) {
                smoother.paused(false);
                if (isLgScreen) ScrollTrigger.normalizeScroll(true);
            } else {
                smoother.paused(true);
                if (isLgScreen) ScrollTrigger.normalizeScroll(false);
            }
        }
    }, [isFormHidden, isDemoFormHidden, isLgScreen]);

    // const handleShowForm = useCallback(() => {
    //     const body = document.body;

    //     if (isFormHidden) {
    //         body.classList.add('hidden');
    //         setIsFormHidden(false);
    //     } else {
    //         body.classList.remove('hidden');
    //         setIsFormHidden(true);
    //     }
    // }, [isFormHidden, setIsFormHidden])

    const handleShowDemoForm = useCallback(() => {
        const body = document.body;

        if (isDemoFormHidden) {
            body.classList.add('hidden');
            setIsDemoFormHidden(false);
        } else {
            body.classList.remove('hidden');
            setIsDemoFormHidden(true);
        }
    }, [isDemoFormHidden, setIsDemoFormHidden])

    return (
        <>
            <ScrollToTopOnMount screens={screens} setIsPageLoaded={setIsPageLoaded} />
            <Header handleShowDemoForm={handleShowDemoForm} screens={screens} className={!isPageLoaded ? 'invisible' : ''} />
            <main className={!isPageLoaded ? 'invisible' : ''}>
                {/* <Form handleShowForm={handleShowForm} isFormHidden={isFormHidden} screens={screens} /> */}
                <DemoForm handleShowDemoForm={handleShowDemoForm} isDemoFormHidden={isDemoFormHidden} screens={screens} />
                <div id="smooth-wrapper">
                    <div id="smooth-content">
                        <Hero screens={screens} isPageLoaded={isPageLoaded} handleShowDemoForm={handleShowDemoForm} />
                        {/* <Listener screens={screens} /> */}
                        {/* <About screens={screens} /> */}
                        {/* <Contact handleShowForm={handleShowForm} screens={screens} /> */}
                    </div>
                </div>
            </main>
            {/* <Footer screens={screens} className={!isPageLoaded && 'invisible'} /> */}
        </>
    )
}

export default Home;
